module.exports = __webpack_public_path__ + "static/media/promo.b3a2123a.png";